import { CSSProperties, SVGProps } from 'react'
import Colors from 'modules/Colors'

/**
 * Props for the YandexFlatIcon component
 * @interface YandexFlatIconProps
 */
interface YandexFlatIconProps extends SVGProps<SVGSVGElement> {
    /** Optional class name for styling */
    className?: string
    /** Optional inline styles */
    style?: CSSProperties
    /** Color of the icon, defaults to red */
    color?: string
    /** Size of the icon in pixels, defaults to 40 */
    size?: number
    /** Optional click handler */
    onClick?: () => void
}

const YandexFlatIcon = ({
    className,
    style,
    color = Colors.red,
    size = 40,
    onClick
}: YandexFlatIconProps) => {
    return (
        <svg
            className={className}
            style={style}
            width={size}
            height={size}
            onClick={onClick}
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g transform="translate(5, 5) scale(0.75)">
                <path
                    d="M24.1424 33.1515V40H15.7879V28.5455L0 0H9.0909L20.3636 22.2424C22.7273 26.5152 23.3939 28.0303 23.3939 33.1515H24.1424ZM40 0L29.7879 19.3939H20.9091L31.1212 0H40Z"
                    fill={color}
                />
            </g>
        </svg>
    )
}

export default YandexFlatIcon
